import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { SelectVehicleModelPage } from './select-vehicle-model';

@NgModule({
  declarations: [SelectVehicleModelPage],
  imports: [IonicPageModule.forChild(SelectVehicleModelPage)],
})
export class SelectVehicleModelPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-vehicle-model/select-vehicle-model.module.ts